import { Color } from '@/components/portfolio/components/sharedTypes'
import { clientHomeData, clientPageData, PortfolioComponent } from '../../type/client-index'
import { BiscuitEmpt, BiscuitTag, Schema1 } from './assets'

export const home: clientHomeData = {
  slug: 'teski',
  name: 'Teski',
  types: ['Identité de marque'],
  image: BiscuitEmpt
}

const detailed: clientPageData = {
  seo: {
    title: 'Teski',
    description: 'Découvrez notre travail avec Teski.'
  },
  blocks: [
    {
      id: 1,
      componentName: PortfolioComponent.presentationSlide,
      props: {
        title: home.name,
        types: home.types,
        titleColor: Color.orange,
        images: [BiscuitEmpt, BiscuitTag],
        urls: {
          website: 'https://www.teski.shop/',
          instagram: 'https://www.instagram.com/teski_biscuits/'
        },
        subtitle: 'La marque',
        descriptionRight: true,
        variant: 2,
        description: {
          cols: 2,
          content: [
            "Marque humaine avant tout, Teski propose à ses clients des biscuits personnalisables. Accompagnés d'une étiquette déjà dessinée ou totalement créée, ils délivrent subtilement un message à la personne choisie. Au cœur de ce concept, une valeur simple et essentielle : le plaisir d'offrir.",
            "Que ce soit au travers de l'attention du cadeau donné, du petit mot imprimé sur les étiquettes ou encore du gâteau offert, Teski veut avant tout toucher les gens et leur faire plaisir. Authentique, épurée ou touchante sont autant d'adjectifs qui qualifient la marque belge. Bien plus que de bons biscuits, Teski propose avant tout un concept fort et plein de sens."
          ]
        }
      }
    },
    {
      id: 2,
      componentName: PortfolioComponent.imageGrid,
      props: {
        title: 'Notre travail',
        description: {
          cols: 2,
          content: [
            "C'est pour travailler son positionnement que Teski a contacté Atelier Milky. Après plusieurs rendez-vous afin d'en apprendre plus sur son histoire, une analyse du marché ainsi que de nombreuses recherches, nous avons créé une identité de marque flambant neuve !",
            "Pour une application facilitée, Teski s'est vue remettre un guide de la marque. Ce document de référence regroupe tous les éléments qui, ensemble, constituent le socle sur lequel repose la communication de l'entreprise. Storytelling, univers sémantique, univers photographique mais aussi recommandations d'activation, Teski est maintenant prête à développer sa communication."
          ]
        },
        images: [],
        variant: 0,
        rightPadding: true
      }
    },
    {
      id: 3,
      componentName: PortfolioComponent.singleImage,
      props: {
        image: Schema1,
        fullHeight: false,
        pr: true,
        py: 32
      }
    }
  ]
}

export default detailed
